import {UserManager, WebStorageStateStore} from "oidc-client-ts";

/**
 * Configuración del proveedor OIDC de Teamsystem (login).
 *
 * Teamsystem es el IdP que autentica al usuario. El access_token que devuelve
 * NO se usa directamente contra nuestra API: se intercambia en
 * `POST {REACT_APP_API_AUTH}/auth/token` por los tokens internos de Identity
 * (ver services/authService.js). Por eso aquí solo manejamos el flujo OIDC puro.
 */
const settings = {
  authority: process.env.REACT_APP_TS_OIDC_AUTHORITY,
  client_id: process.env.REACT_APP_TS_OIDC_CLIENT_ID,
  client_secret: process.env.REACT_APP_TS_OIDC_CLIENT_SECRET || undefined,
  redirect_uri: process.env.REACT_APP_TS_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_TS_OIDC_POST_LOGOUT_REDIRECT_URI,
  scope: process.env.REACT_APP_TS_OIDC_SCOPE || "openid profile email",
  response_type: process.env.REACT_APP_TS_OIDC_RESPONSE_TYPE || "code",
  // El callback maneja la redirección manualmente tras el token exchange.
  automaticSilentRenew: false,
  loadUserInfo: false,
  filterProtocolClaims: true,
  // Estado del flujo OIDC (code verifier PKCE, nonce, etc.) en sessionStorage.
  stateStore: new WebStorageStateStore({store: window.sessionStorage}),
  userStore: new WebStorageStateStore({store: window.sessionStorage})
};

/**
 * Instancia única de UserManager. Reutilizarla evita perder el estado PKCE
 * entre el inicio del login y el callback.
 */
export const userManager = new UserManager(settings);

/**
 * Inicia el redirect al login de Teamsystem.
 * Acepta los args de oidc-client-ts (p. ej. { extraQueryParams: { prompt: "login" } }
 * para forzar la reautenticación y que TS ID vuelva a pedir el correo).
 */
export const signinRedirect = (args) => userManager.signinRedirect(args);

/** Procesa el retorno de Teamsystem (?code=...) y resuelve el User de Teamsystem. */
export const signinRedirectCallback = () => userManager.signinRedirectCallback();

/** Cierra sesión en Teamsystem y limpia su estado local. */
export const signoutRedirect = () => userManager.signoutRedirect();
